import { Modal } from '@pimm/base';
import { DashboardModalType, useDashboard } from '@app/features/dashboard';
import { DeliveryMonitor } from '@app/features/delivery-monitor/components/delivery-monitor';

export const ModalDeliveryMonitor = () => {
  const { modal, toggleModal } = useDashboard();
  return (
    <Modal
      hideClose
      _content={{ rounded: '2xl', px: 4, maxWidth: 846 }}
      size="full"
      isOpen={modal?.type === DashboardModalType.DeliveryMonitor}
      onClose={toggleModal}
    >
      <DeliveryMonitor onClose={() => toggleModal()} />
    </Modal>
  );
};
